//src/components/Navbar.tsx

"use client";

import Link from "next/link";
import Image from "next/image";
import { PLATFORM_URL } from "@/config/platform";

export default function Navbar() {
  return (
    <header className="w-full bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LOGO */}
        <Link href="/" className="flex items-center">
         <Image
  src="/logo-nav.png"
  alt="MaconJob"
  width={220}
  height={80}
  className="w-[160px] md:w-[220px]"
/>
          
        </Link>

        {/* MENU */}
        <nav className="hidden md:flex items-center gap-8 text-sm">

        <Link
  href="/annunci"
  className="hover:text-green-400 transition"
>
  Annunci
</Link>

          <Link
            href="/professionisti"
            className="hover:text-green-400 transition"
          >
            Professionisti
          </Link>

          <Link
            href="/societa"
            className="hover:text-green-400 transition"
          >
            Società
          </Link>

        </nav>

        {/* CTA */}
       <div className="flex items-center gap-4">

  <a
    href={`${PLATFORM_URL}/login`}
    target="_self"
    className="text-sm hover:text-green-400"
  >
    Login
  </a>

</div>

      </div>
    </header>
  );
}